<h4 class="font-app-bold text-darkest text-sm md:text-base">
  {{ "scholarInsurance.title" | translate }}
</h4>
<div class="flex justify-between mt-3 text-sm">
  <span class="font-app-regular text-dark text-sm md:text-base">
    {{ "scholarInsurance.nbChild" | translate }}
  </span>
  <span class="font-app-regular text-darkest text-sm md:text-base">
    {{ children.length }}
  </span>
</div>
<div
  *ngFor="let child of children; let first = first; let i = index"
  class="mt-2">
  <span class="text-sm md:text-base"
    >{{ i + 1 }}{{ (first ? "scholarInsurance.firstChild" : "scholarInsurance.nthChild") | translate }}</span
  >
  <span class="ml-1 text-sm md:text-base">{{ "scholarInsurance.child" | translate }}</span>
  <div class="flex items-end mt-2">
    <div class="items-center justify-between w-full">
      <span class="font-app-regular text-dark text-sm md:text-base col-start-1">{{
        "scholarInsurance.firstName" | translate
      }}</span>
    </div>
    <span class="text-sm md:text-base font-app-regular text-darkest">{{ child.firstName }}</span>
  </div>
  <div class="flex items-end mt-2">
    <div class="items-center justify-between w-full">
      <span class="font-app-regular text-dark text-sm md:text-base col-start-1">{{
        "scholarInsurance.lastName" | translate
      }}</span>
    </div>
    <span class="text-sm md:text-base font-app-regular text-darkest">{{ child.lastName }}</span>
  </div>
  <div class="flex items-end mt-2">
    <div class="items-center justify-between w-full">
      <span class="font-app-regular text-dark text-sm md:text-base col-start-1">{{
        "scholarInsurance.birthDate" | translate
      }}</span>
    </div>
    <span class="text-sm md:text-base font-app-regular text-darkest">{{ child.birthDate }}</span>
  </div>
  <p-divider type="solid"></p-divider>
</div>

